export default __webpack_public_path__ + "static/media/instructions-display-shape.5973850e.png";